import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Partnerone from "../assets/partnerone.png";
import Partnertwo from "../assets/partnertwo.png";
import Partnerthree from "../assets/partnerthree.png";
import Partnerfour from "../assets/partnerfour.png";
import Partnerfive from "../assets/partnerfive.png";
import axiosInstance from "@/axios";
import { toast } from "react-toastify";

const TrustedBrandsPage = () => {
  const { t } = useTranslation();

  const awards = [
    {
      id: 1,
      image: Partnerone,
      title: t("2020 Gold Winner"),
      description: t("For Customer Service by Stevie Awards"),
    },
    {
      id: 2,
      image: Partnerfive,
      title: t("2020 Winner"),
      description: t("Innovations in Edtech by Aegis Graham Bell Award"),
    },
    {
      id: 3,
      image: Partnertwo,
      title: t("2020 Winner"),
      description: t("Online Learning Library Training Industry"),
    },
    {
      id: 4,
      image: Partnerthree,
      title: t("2019 Winner"),
      description: t("Online Learning Library Training Industry"),
    },
    {
      id: 5,
      image: Partnerfour,
      title: t("2018 Gold Winner"),
      description: t("For Customer Service by Stevie Awards"),
    },
  ];

  const partners = [
    { id: 1, logo: Partnerone, name: t("PTI") },
    { id: 2, logo: Partnertwo, name: t("KGC") },
    { id: 3, logo: Partnerthree, name: t("Transformative") },
    { id: 4, logo: Partnerfour, name: t("Guild") },
    { id: 5, logo: Partnerfive, name: t("InStride") },
    { id: 6, logo: Partnerfour, name: t("Degreed") },
    { id: 7, logo: Partnertwo, name: t("IBM") },
    { id: 8, logo: Partnerone, name: t("WPP") },
    { id: 9, logo: Partnerfour, name: t("OmniSesame") },
  ];
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    targetSegment: "",
    yearsInBusiness: "",
    annualRevenue: "",
    partnershipType: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axiosInstance.post("/request/partner-request", formData);
      toast.success("Submitted successfully!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        company: "",
        targetSegment: "",
        yearsInBusiness: "",
        annualRevenue: "",
        partnershipType: "",
      });
    } catch (err) {
      toast.error("Failed to submit!");
    }
  };
  return (
    <div className="bg-black/5">
      <div className=" container mx-auto px-4 py-8 max-w-7xl">
        {/* Trusted Brands Section */}
        {/* <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-10">
          {t("We Are One of the Most Trusted Brands")}
        </h2> */}

       {/*  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-16">
          {awards.map((award) => (
            <div
              key={award.id}
              className="flex flex-col items-center text-center"
            >
              <img
                src={award.image || "/placeholder.svg"}
                alt={award.title}
                className="h-24 w-24 md:h-28 md:w-28 object-contain mb-4"
              />
              <h3 className="font-semibold text-sm md:text-base mb-1">
                {award.title}
              </h3>
              <p className="text-xs md:text-sm !text-gray-600">
                {award.description}
              </p>
            </div>
          ))}
        </div> */}

        {/* Partners Section */}
        <div className="flex flex-col md:flex-row gap-8 mt-16">
          <div className="w-full md:w-1/2">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-8">
              {t("Partners to Global Brands")}
            </h2>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 bg-blue-50 bg-opacity-30 p-4 rounded-lg">
              {partners.map((partner) => (
                <div
                  key={partner.id}
                  className="bg-white p-4 flex items-center justify-center h-24 rounded-md shadow-sm"
                >
                  <img
                    src={partner.logo || "/placeholder.svg"}
                    alt={partner.name}
                    className="max-h-28 max-w-full object-contain"
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="w-full md:w-1/2 bg-white p-6 rounded-lg shadow-sm">
            <h2 className="text-xl font-bold text-center text-gray-800 mb-6">
              {t("Ready to Partner with us?")}
            </h2>

            <form className="space-y-4" onSubmit={handleSubmit}>
              <div>
                <label htmlFor="name" className="text-sm text-gray-600">
                  {t("Name*")}
                </label>
                <input
                  type="text"
                  id="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder={t("Enter your name")}
                  className="w-full border border-gray-300 rounded p-2 mt-1"
                  required
                />
              </div>

              <div>
                <label htmlFor="email" className="text-sm text-gray-600">
                  {t("Business Email*")}
                </label>
                <input
                  type="email"
                  id="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder={t("Enter your business email")}
                  className="w-full border border-gray-300 rounded p-2 mt-1"
                  required
                />
              </div>

              <div className="flex items-center gap-2">
                <div className="flex-1">
                  <label htmlFor="phone" className="text-sm text-gray-600">
                    {t("Phone Number*")}
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder={t("Enter your phone number")}
                    className="w-full border border-gray-300 rounded p-2 mt-1"
                    required
                  />
                </div>
              </div>

              <div>
                <label htmlFor="company" className="text-sm text-gray-600">
                  {t("Company*")}
                </label>
                <input
                  type="text"
                  id="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder={t("Enter your company name")}
                  className="w-full border border-gray-300 rounded p-2 mt-1"
                  required
                />
              </div>

              <div>
                <label htmlFor="targetSegment" className="text-sm text-gray-600">
                  {t("Target Segment*")}
                </label>
                <select
                  id="targetSegment"
                  value={formData.targetSegment}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded p-2 mt-1 bg-white"
                  required
                >
                  <option value="">{t("Select target segment")}</option>
                  <option value="B2B">B2B</option>
                  <option value="B2C">B2C</option>
                  <option value="Enterprise">Enterprise</option>
                </select>
              </div>

              <div>
                <label htmlFor="yearsInBusiness" className="text-sm text-gray-600">
                  {t("Years in Business*")}
                </label>
                <select
                  id="yearsInBusiness"
                  value={formData.yearsInBusiness}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded p-2 mt-1 bg-white"
                  required
                >
                  <option value="">{t("Select years in business")}</option>
                  <option value="1-3">1-3</option>
                  <option value="4-6">4-6</option>
                  <option value="7+">7+</option>
                </select>
              </div>

              <div>
                <label htmlFor="annualRevenue" className="text-sm text-gray-600">
                  {t("Annual Revenue*")}
                </label>
                <select
                  id="annualRevenue"
                  value={formData.annualRevenue}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded p-2 mt-1 bg-white"
                  required
                >
                  <option value="">{t("Select annual revenue")}</option>
                  <option value="<1M">Less than $1M</option>
                  <option value="1M-10M">$1M - $10M</option>
                  <option value="10M+">Over $10M</option>
                </select>
              </div>

              <div>
                <label htmlFor="partnershipType" className="text-sm text-gray-600">
                  {t("Partnership Type*")}
                </label>
                <select
                  id="partnershipType"
                  value={formData.partnershipType}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded p-2 mt-1 bg-white"
                  required
                >
                  <option value="">{t("Select partnership type")}</option>
                  <option value="Reseller">Reseller</option>
                  <option value="Affiliate">Affiliate</option>
                  <option value="Strategic">Strategic</option>
                </select>
              </div>

              {/* <div className=" border gap-2">
              <input
                type="checkbox"
                id="privacyPolicy"
                className="mt-1"
                required
              />
              <label htmlFor="privacyPolicy" className="text-xs text-gray-600">
                {t("By providing your contact details, you agree to our")}{" "}
                <a href="#" className="text-blue-600 ml-1">
                  {t("Privacy Policy")}
                </a>
              </label>
            </div> */}

              <button
                type="submit"
                className="w-full bg-blue-500 text-white py-3 rounded font-medium hover:bg-blue-600 transition-colors"
              >
                {t("SUBMIT")}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustedBrandsPage;
